module.exports = __webpack_public_path__ + "static/media/noclass8.7ef9d5ba.png";